import { useUIStore } from '../../../store/uiStore';
import type { Slide } from './deck';

/**
 * Centers the map on a slide's subject — the structure it is attached to,
 * or the post itself when it stands alone. Both surfaces' address lines
 * call this; fullscreen drops its overlay first, since the map it is about
 * to move sits behind it.
 */
export function focusMapOnSlide(slide: Slide): void {
  const ui = useUIStore.getState();
  if (slide.post.structureId) {
    ui.requestMapFocus(slide.post.structureId);
  } else {
    ui.requestMapPostFocus(slide.post.id);
  }
}
